import { isSessionStorageSupported } from '@zillow/is-local-storage-supported';
import { MaybeString } from 'src/common/types';
import { isNull } from 'src/utils/typeguards/isNull';
import { isUndefined } from 'src/utils/typeguards/isUndefined';

export const getRawSessionStorageItem = (storageKey: string): MaybeString => {
    if (isSessionStorageSupported()) {
        return globalThis.sessionStorage.getItem(storageKey);
    }
    return undefined;
};

export const setRawSessionStorageItem = (storageKey: string, value: string): void => {
    if (isSessionStorageSupported()) {
        globalThis.sessionStorage.setItem(storageKey, value);
    }
};

/**
 * Gets a value and JSON parses from session storage if it exists and session storage is supported
 */
export const getParsedSessionStorageItem = <TReturnType = unknown>(
    storageKey: string
): TReturnType | null | undefined => {
    try {
        const rawSessionStorageItem = getRawSessionStorageItem(storageKey);
        if (isNull(rawSessionStorageItem)) {
            return null;
        }
        if (isUndefined(rawSessionStorageItem)) {
            return undefined;
        }
        return JSON.parse(rawSessionStorageItem) as TReturnType;
    } catch {}
};

/**
 * Sets a value into session storage with a given key, stringifies non-primitives
 */
export const setSessionStorageItem = <TItemType = unknown>(storageKey: string, item: TItemType) => {
    if (isSessionStorageSupported()) {
        globalThis.sessionStorage.setItem(storageKey, JSON.stringify(item));
    }
};

export const deleteSessionStorageItem = (storageKey: string) => {
    if (isSessionStorageSupported()) {
        globalThis.sessionStorage.removeItem(storageKey);
    }
};
